exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CarItemPreview .header, .CarItemPreview .content {\n  padding: 0.9rem 1.1rem;\n  background-color: #fff;\n  border-right: 1px solid rgba(0, 0, 0, 0.03);\n  margin-top: .1rem;\n  margin-bottom: .2rem;\n  width: 100%;\n  color: #484848;\n  border-radius: 6px;\n  -webkit-box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);\n  box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);\n  font-size: 1em;\n  font-weight: 600;\n  line-height: 1.375em; }\n\n.CarItemPreview .content {\n  margin: auto;\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1em; }\n", ""]);

// exports
